module.exports = __webpack_public_path__ + "static/polityka_prywatnosci_i_cookies_en-e389c9a746b5a475b614479192eb2d36.pdf";